import { ReactNode } from 'react'

interface SectionProps {
 id: string
 title?: string
 className?: string
 children: ReactNode
}

export function Section({ id, title, children, className }: SectionProps) {
 return (
  <section
   id={id}
   aria-labelledby={title ? `${title}` : undefined}
   className={className}
  >
   {children}
  </section>
 )
}
